import { apiV2 } from 'lib/api/v2'
import useSWR from 'swr'

import { useIsRecardingEnabled } from 'hooks/useIsRecardingEnabled'

async function fetcher(): Promise<number> {
  const { data } = await apiV2.get<number>('private/card/reissue/pending/count')

  return data
}

export function useRecardingPendingCount() {
  const isRecardingEnabled = useIsRecardingEnabled()

  return useSWR(
    isRecardingEnabled ? ['getRecardingPendingCount'] : null,
    fetcher
  )
}
